export const isLazyLoadSupported = () => {
  return "loading" in HTMLImageElement.prototype; 
};
